/* eslint-disable security/detect-possible-timing-attacks */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import * as Msdyn from '@msdyn365-commerce/core';

import { ICheckoutGuestProfileViewProps } from './google-captcha-verification';

const CheckoutGuestProfileView: React.FC<ICheckoutGuestProfileViewProps> = ({
    moduleProps,
    checkoutErrorRef,
    alert,
    onCaptchaCallback,
    isVerified,
    context,
    byPass
}) => {
    const recaptchaRef = React.useRef<any>();

    const captchaSiteKey = context.app.config.reCaptchaSiteKey;
    const [isRECaptchaLoaded, setIsRECaptchaLoaded] = React.useState(false);

    const onReCaptchaLoad = () => {
        setIsRECaptchaLoaded(true);
    };

    if (Msdyn.msdyn365Commerce.isBrowser) {
        React.useEffect(() => {
            // Assign the component function to the window callback
            // @ts-ignore
            window.onReCaptchaLoad = onReCaptchaLoad;

            // @ts-ignore
            if (!window.grecaptcha) {
                // Load the script only if it's not already available
                const script = document.createElement('script');
                script.src = 'https://www.google.com/recaptcha/api.js?onload=onReCaptchaLoad&render=explicit';
                script.async = true;
                script.defer = true;
                document.head.append(script);
                // @ts-ignore
            } else if (window.grecaptcha) {
                // @ts-ignore
                window.grecaptcha.reset();
                // If reCAPTCHA is already loaded, call the function directly
                onReCaptchaLoad();
            }

            // Clean up the global callback on component unmount
            return () => {
                // @ts-ignore
                window.onReCaptchaLoad = null;
            };
        }, []);
    }

    React.useEffect(() => {
        if (isRECaptchaLoaded) {
            // @ts-ignore
            window.grecaptcha.render(recaptchaRef.current, {
                sitekey: captchaSiteKey,
                callback: onCaptchaCallback
            });
        }
    }, [isRECaptchaLoaded]);

    return (
        <Module {...moduleProps} ref={checkoutErrorRef}>
            {alert}
            {/* <button onClick={byPass}>Verify </button> */}
            {isVerified && (
                <div className='ms-checkout__guided-card-body'>
                    <div className='ms-checkout__guided-card-content'>
                        <div className='ms-checkout-delivery-options' id='' data-m-t='c-checkout-delivery-options'>
                            <div className='ms-checkout-delivery-options__option-selected'>
                                <span className='ms-checkout-delivery-options__description'>Successfully verifed ✅</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {!isVerified && <div className='ml-g-recaptcha' ref={recaptchaRef}></div>}
        </Module>
    );
};

export default CheckoutGuestProfileView;
